import { useToast } from '@cad-arc';
import React from 'react';
import { createApiErrorHandler } from '@m43/core';
import { useApiClient } from '~/api-client';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';
import { useOpenDepartmentLink } from '../use-open-department-link';
import { ReportscreateResource } from '@mark43/rms-api';

type GenerateRepossession = () => void;

export function useGenerateRepossession(): GenerateRepossession {
    const apiClient = useApiClient();
    const bootstrapState = useBootstrapState();
    const openDepartmentLink = useOpenDepartmentLink();
    const toast = useToast();
    return React.useMemo(() => {
        const generateRepossession: GenerateRepossession = () => {
            const agencyId = bootstrapState.userProfileView.departmentAgencyId;
            apiClient
                .request<ReportscreateResource.CreateTowVehicleReportByGeneratingRepossession>({
                    service: 'RMS',
                    method: 'POST',
                    url: `reports/create/tow_vehicle/${agencyId}/`,
                })
                .then((response) => {
                    const data = response.data.data;
                    if (data) {
                        openDepartmentLink({
                            path: `reports/${data.id}`,
                            app: 'RMS',
                            tenantStrategy: 'PREFER_RMS_TENANT',
                        });
                        const renLabel =
                            bootstrapState.fieldDisplayNameByFieldName[
                                'AGENCY_EVENT_REPORTING_EVENT_NUMBER'
                            ];
                        const renValue = data.recordNumber;
                        toast({
                            status: 'default',
                            description: `${renLabel} ${renValue} generated for Repossession`,
                        });
                    }
                })
                .catch(
                    createApiErrorHandler(() => {
                        const renLabel =
                            bootstrapState.fieldDisplayNameByFieldName[
                                'AGENCY_EVENT_REPORTING_EVENT_NUMBER'
                            ];
                        toast({
                            status: 'error',
                            description: `Error Generating ${renLabel} for Repossession`,
                        });
                    })
                );
        };
        return generateRepossession;
    }, [
        apiClient,
        bootstrapState.fieldDisplayNameByFieldName,
        bootstrapState.userProfileView.departmentAgencyId,
        openDepartmentLink,
        toast,
    ]);
}
